import React, { useContext } from 'react';

const ReportContext = React.createContext(null);

export default ReportContext;

export function useReportContext() {
    return useContext(ReportContext);
}
